function defaultGraph () {
  return ''
}

module.exports = defaultGraph
